import React, { useState } from "react";
import useStore from "../../helpers/useStore";
import { NavTablesContext } from "../../stores/NavTables";
import { observer } from "mobx-react";
import { PatientCommands } from "../../stores/Patients/patient.commands";
import { PatientsContext } from "../../stores/Patients/patients.provider";
import { PATIENT_SUBTABS } from "../../stores/Patients/patientsStore";
import { useNavigate } from "react-router";
import RxsTableDialog from "../../molecules/PatientRxTables/RxsTable";

const RxNavigationPane: React.FC = observer(() => {
  const navigate = useNavigate();

  const PatientStore = useStore(PatientsContext);
  const { navigateToPatient } = PatientCommands(PatientStore);

  const NavTablesStore = useStore(NavTablesContext);
  const { rxNavTableIsOpen, setRxNavTableIsOpen } = NavTablesStore;

  const handleCloseDialog = () => {
    setRxNavTableIsOpen(false);
  };

  // update the selected row in the store, navigate to rx and close
  const handleRxSelect = (patientId: number, rxId: string) => {
    navigateToPatient(navigate, patientId,rxId, PATIENT_SUBTABS.PRESCRIPTIONS);

    handleCloseDialog();
  };

  return (
    <RxsTableDialog 
      open={rxNavTableIsOpen}
      onClose={handleCloseDialog}
      onRxSelect={handleRxSelect}
    />
  );
});

export default RxNavigationPane;
